!/**
* @Description:本书测试
* @author Wangshu
* @date 2020/4/21
*/
<template>
    <div>
        <transition name="el-fade-in-linear">
            <div class="el-message-box__wrapper" style="z-index: 1250;" v-if="testPaper">
                <div class="el-message-box">
                    <div class="el-message-box__header">
                        <div class="el-message-box__title" style="font-size: 20px;font-weight: bold">本书测试</div>
                        <div class="btn1" @click="$router.go(-1)">
                            <img src="@/assets/img/grammarTest/close.png" alt="">
                        </div>
                        <div class="btn2">
                            <img v-if="paused" class="animated fadeInLeft" @click="playBgMusic"
                                 src="@/assets/img/grammarTest/music.png" alt="">
                            <img v-else class="animated fadeInRight" @click="playBgMusic"
                                 src="@/assets/img/grammarTest/pause.png" alt="">
                            <audio id="bgMusic" src="@/assets/audio/audio.flac" autoplay></audio>
                        </div>
                    </div>
                    <div class="el-message-box__content">
                        <div class="el-message-box__container">
                            <!--                            <div class="left-title">-->
                            <!--                                自主测试：自由选择测试的方式与试题数目，用以巩固学习效果。-->
                            <!--                            </div>-->
                        </div>
                        <div class="book-content-box">
                            <transition name="el-fade-in-linear" mode="out-in">
                                <div class="option-box">
                                    <div class="test-tilt" key="save">
                                        测试选项
                                    </div>
                                    <div class="option">
                                        <div class="option-item">
                                            <div>测试内容：</div>
                                            <el-checkbox-group v-model="checkList" size="medium">
                                                <el-checkbox label="英译汉">英译汉</el-checkbox>
                                                <el-checkbox label="汉译英">汉译英</el-checkbox>
                                                <el-checkbox label="听写">听写</el-checkbox>
                                                <el-checkbox label="听选">听选</el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                        <div class="push-btn">
                                            <el-button type="success" @click="startComparisonTest">开始测试</el-button>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="el-fade-in-linear" mode="out-in">
            <test-paper
                    ref="testPaper"
                    :type="testPaperType"
                    :showComparison="showComparison"
                    :option="option"
                    @closeComparison="closeText">
            </test-paper>
        </transition>
    </div>
</template>

<script>
    import testPaper from '../../templates/testPaper/testPaper'
    import Lockr from 'lockr'

    export default {
        name: "testOption",
        components: {testPaper},
        data() {
            return {
                courseId: '',//课程id
                unitList: [],//单元列表
                testPaper: true,
                checkList: [],
                options: [
                    {value: '10', label: '10'},
                    {value: '15', label: '15'},
                    {value: '20', label: '20'},
                ],
                showComparison: false,
                testPaperType: '4',//控制组件使用的接口
                option: {
                    name: '本书测试',
                    testPaperId: '',//单元Id
                    is_one: 0,//是否有英译汉
                    is_two: 0,//是否有汉译英
                    is_three: 0,//是否有听选
                    is_four: 0,//是否有听写
                    grammarNum: '10',
                },
                paused: true,
            };
        },
        methods: {
            // 开始本书测试
            startComparisonTest() {
                this.checkList.map(item => {
                    item == '英译汉' ? this.option.is_one = 1 : ''
                    item == '汉译英' ? this.option.is_two = 1 : ''
                    item == '听选' ? this.option.is_three = 1 : ''
                    item == '听写' ? this.option.is_four = 1 : ''
                })
                if (this.option.is_one == '' && this.option.is_two == '' && this.option.is_three == '' && this.option.is_four == '') {
                    this.$alert('请选择测试的内容哦~', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                    });
                } else {
                    this.showComparison = true
                    this.testPaper = false
                    this.option.testPaperId = this.$route.query.id
                    this.$refs.testPaper.getTestPaper()
                }
            },
            // 关闭测试
            closeText() {
                this.showComparison = false
                this.$router.go(-1)
            },
            playBgMusic() {
                let buttonAudio = document.getElementById('bgMusic');
                if (buttonAudio.paused) {
                    // 暂停中
                    buttonAudio.play()
                    this.paused = true
                } else {
                    // 播放中
                    buttonAudio.pause()
                    this.paused = false
                }
            },
        },
        created() {

        },
    }
</script>

<style scoped lang='less'>

    .el-message-box {
        width: 1020px;
        position: relative;
        background: url('../../../../assets/img/pop_border.png') no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        border: none;
        padding: 0 60px;
    }

    .el-message-box__wrapper {
        background: rgba(0, 0, 0, 0.3);

        .el-message-box__header {
            padding-top: 35px;
            border-bottom: 1px solid #dcdcdc;

            .btn1, .btn2 {
                top: 23px;
            }
        }

        .el-message-box__content {
            /*padding-left: 80px;*/
        }

        .paper-el-message-box {
            padding-left: 20px;
        }


        .left-title {
            font-size: 14px;
            font-weight: bold;
            color: #333;
            height: 44px;
            line-height: 44px;
            background: #FFF9EF;
            border-radius: 4px;
            border: 1px solid #F5A623;
            padding: 0 20px;
            margin-top: 10px;
        }

        .book-content-box {
            height: 450px;
            transition: all .5s;

        }


    }

    .option-box {
        .test-tilt {
            font-size: 26px;
            text-align: center;
            margin-top: 25px;
        }

        .option {
            margin: 0 auto;
            margin-top: 80px;
            width: 550px;

            .option-item {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin: 20px 0;
                font-size: 22px;

                > div:nth-of-type(1) {
                    margin-left: 20px;
                }

                > div:nth-of-type(2) {
                    .el-checkbox__label {
                        font-size: 30px;
                    }
                }


            }
        }

        .push-btn {
            text-align: center;
            margin-top: 100px;
        }
    }
</style>